<template>
  <div class="animated fadeIn list-of-so">
    <b-card v-if="(showView==false)">
      <div slot="header">
        Customer/Sales Order
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add" v-if="(SoMenu!='receivable.customerorder')">Add</b-button>
          <b-button variant="primary mr-1" @click="edit" v-if="(SoMenu!='receivable.customerorder')">Edit</b-button>
          <b-button variant="primary mr-1" @click="deleteConfirm" v-if="(SoMenu!='receivable.customerorder')">Delete</b-button>
          <b-button variant="primary mr-1" @click="print()">Print</b-button>
          <b-button variant="primary mr-1" @click="approvalConfirm()" v-if="(SoMenu!='receivable.customerorder')"><i class="fa fa-paper-plane"></i> Approval</b-button>
          <b-button variant="primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>Export
          </b-button>
          <b-button variant="primary mr-1" @click="togleFilter()">
            <i class="fa fa-filter"></i> Filter
          </b-button>
          <button class="btn btn-danger mr-1" @click="close()" v-if="showView==false">
            <i class="fa fa-close"></i> Close
          </button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend><label>Order Date</label></b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date"></b-form-input>
            <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
            <b-form-input v-model="tblData.tgl2" type="date"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Order Number</label></b-input-group-prepend>
            <b-form-input v-model="tblData.nomor" placeholder="sales order number"></b-form-input>
            <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Doc. Reference</span></b-input-group-prepend>
            <b-form-input v-model="tblData.ExtrDocNo" placeholder="external  doc. no"></b-form-input>
          </b-input-group>
          <!-- <b-input-group>
            <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
            <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
            <b-input-group-prepend><span class="input-group-text">value</span></b-input-group-prepend>
            <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input>
          </b-input-group> -->
          <b-input-group>
            <b-input-group-prepend><label>Customer</label></b-input-group-prepend>
            <b-form-input v-model="tblData.customer" ></b-form-input>
            <b-input-group-append>
              <b-btn variant="primary" @click="lkuKoranCustShow=true"> <i class="fa fa-search"></i></b-btn>
            </b-input-group-append>
            <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Advertiser</span></b-input-group-prepend>
            <b-form-input v-model="tblData.Advertiser"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="6">

          <b-input-group>
            <b-input-group-prepend><label>Sales AE</label></b-input-group-prepend>
            <b-form-input v-model="tblData.salesae_name" placeholder="Sales (AE)" @change="tblData.salesid_id=''"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuSalesShow=true" variant="primary"><i class="fa fa-search"></i></b-btn>
            </b-input-group-append>
            <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Campaign</span></b-input-group-prepend>
                <b-form-input v-model="tblData.campaign" ></b-form-input>
                <b-input-group-append>
                  <b-btn variant="primary" @click="lkuSalesCamapignShow=true"> <i class="fa fa-search"></i></b-btn>
                </b-input-group-append>
          </b-input-group>

              <b-input-group >
                <b-input-group-prepend><label >Billing Term</label></b-input-group-prepend>
                <b-form-select v-model="tblData.billing" :plain="true" :options="invoicingTerms" style="width:20% !important;"></b-form-select>
                <b-input-group-prepend><span class="input-group-text">Telah diinvoice</span></b-input-group-prepend>
                  <b-form-select v-model="tblData.isinvoiced" :plain="true" :options="YesNoAll"></b-form-select>
                <b-input-group-prepend><span class="input-group-text">Komplit</span></b-input-group-prepend>
                  <b-form-select v-model="tblData.completed" :plain="true" :options="YesNoAll"></b-form-select>
              </b-input-group>
            <b-input-group>
                <b-input-group-prepend><label>Bentuk Bayar</label></b-input-group-prepend>
                  <b-form-select v-model="tblData.jenisbayar" :plain="true" :options="paymentForms"></b-form-select>
                <b-input-group-prepend><span class="input-group-text">Uraian</span></b-input-group-prepend>
                <b-form-input v-model="tblData.uraian" style="width:21% !important;"></b-form-input>
                <b-input-group-append>
                      <b-button variant="success" size="sm" @click="search()" class="ml-2"> <i class="fa fa-refresh"></i> Apply Filter</b-button>                
                </b-input-group-append>
                <b-input-group-append>
                      <b-button variant="secondary" size="sm" class="ml-1" @click="clearFilter()" >Clear Filter</b-button>
                </b-input-group-append>
            </b-input-group>

        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        hover
        small
        style="font-size:smaller;"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="rowClicked"
        show-empty
      >
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowView(data.item)" href="#"  style="padding:0 !important;">View</b-dropdown-item>
          <b-dropdown-item @click="rowEdit(data.item)" href="#"  style="padding:0 !important;" v-if="(SoMenu!='receivable.customerorder')" >Edit</b-dropdown-item>
          <b-dropdown-item @click="rowPrint(data.item)" href="#" style="padding:0 !important;">Print Form</b-dropdown-item>
          <b-dropdown-item @click="rowApproval(data.item)" href="#" style="padding:0 !important;" v-if="(SoMenu!='receivable.customerorder')" >Approval</b-dropdown-item>
          <b-dropdown-item @click="rowDel(data.item)" href="#"  style="padding:0 !important;" v-if="(SoMenu!='receivable.customerorder')" > Delete</b-dropdown-item>
        </b-dropdown>
      </template>        

        <template v-slot:cell(OrderDate)="data">{{ data.item.OrderDate | moment('DDMMMYYYY')}}</template>
        <template v-slot:cell(ExtrDocNo)="data">{{ data.item.ExtrDocNo}}
              <b-link v-if="(data.item.attchFileNm)" @click="attachmentDownload(data.item)"><i class="fa fa-paperclip"></i></b-link>
        </template>
        <template v-slot:cell(ttlratecard)="data">{{ data.item.ttlratecard | numFormat }}</template>
        <template v-slot:cell(savingvalue)="data">{{ data.item.savingvalue | numFormat }}</template>
        <template v-slot:cell(ttldiskon)="data">{{ data.item.ttldiskon | numFormat }}</template>
        <template v-slot:cell(ttlnetto)="data">{{ data.item.ttlnetto | numFormat }}</template>
        <template v-slot:cell(invoicetot)="data">{{ data.item.invoicetot}}
              <b-link v-if="(data.item.invoicetot)" @click="getInvoices(data.item)">{{ data.item.invoicetot | numFormat }}</b-link>
              <span v-else>{{ data.item.invoicetot | numFormat }}</span>
        </template>
        <template v-slot:cell(status)="data">
          <div v-if="data.item.send2wf==0" style="background-color:yellow;">           
            DRAFT
          </div>
          <div v-else> 
            <div v-if="data.item.iscomplete==0">           
              ON PROCESS
            </div>
            <div v-else>           
                <div v-if="data.item.issuccess==1"  style="background-color:#04f681;">           
                  APPROVED
                </div>
                <div v-else style="background-color:#f86c6b;">           
                  REJECTED
                </div>
            </div>
          </div>
        </template>

        <template v-slot:cell(empty)="scope">
          <h4>{{ scope.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="scope">
          <h4>{{ scope.emptyFilteredText }}</h4>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to
            <span
              v-if="((tblData.page * tblData.limit)>tblData.total)"
            >{{tblData.total}}</span>
            <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label="Limit per page" class="mb-0">
          <b-form-input v-model="limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit} records`" style="max-width:80px; !important;"></b-form-input>  
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination
            align="right"
            v-if="pagination" 
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>

        <b-card v-if="(showView==true)">
            <div slot="header">
                View - Customer/Sales Order
                <div class="card-header-actions">
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-row>
                <b-col lg="8">
                    <b-input-group>
                        <b-input-group-prepend><label>Order Number</label></b-input-group-prepend>
                        <b-form-input v-model="viewdata.nomor" readonly></b-form-input>
                        <b-input-group-prepend><label class="pl-2">&nbsp;&nbsp; Order Date</label></b-input-group-prepend>
                        <b-form-input v-model="viewdata.OrderDate" type="date" disabled></b-form-input>                                        
                    </b-input-group>
                    <b-row>
                        <b-col lg="10" xl="8">
                            <b-input-group >
                                <b-input-group-prepend><label>Customer/Agency</label></b-input-group-prepend>
                                <b-form-input placeholder="Pilih Biro Iklan" v-model="viewdata.custinfo" readonly></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col lg="6" v-if="(user.iklan==1)">
                          <b-input-group >
                              <b-input-group-prepend><label>Advertiser</label></b-input-group-prepend>
                                <b-form-input placeholder="Masukkan Advertiser" v-model="viewdata.Advertiser" disabled></b-form-input>
                          </b-input-group>
                        </b-col>
                        <b-col lg="6">
                          <b-input-group >
                              <b-input-group-prepend><label>Doc. Reference</label></b-input-group-prepend>
                                <b-form-input v-model="viewdata.ExtrDocNo" placeholder="external doc." disabled></b-form-input>
                          </b-input-group>
                        </b-col>
                    </b-row>    

                    <b-input-group>
                        <b-input-group-prepend><label>Brand</label></b-input-group-prepend>
                        <b-form-input placeholder="Masukkan Brand" v-model="viewdata.brand" disabled></b-form-input>
                          <b-input-group-prepend><label class="pl-2">&nbsp;&nbsp; Category</label></b-input-group-prepend>
                        <b-form-input placeholder="Masukkan Category" v-model="viewdata.kategori" disabled></b-form-input>
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend><label>Note/Descript.</label></b-input-group-prepend>
                        <b-form-input v-model="viewdata.uraian" maxlength="250"  disabled></b-form-input>
                    </b-input-group>

                </b-col>
                <b-col md="4">
                    <b-input-group>
                        <b-input-group-prepend><label>Sales/AE</label></b-input-group-prepend>
                        <b-form-input v-model="viewdata.SalesEx" readonly></b-form-input>
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend><label>Campaign</label></b-input-group-prepend>
                        <b-form-input v-model="viewdata.campaign" readonly></b-form-input>
                    </b-input-group>
                </b-col>
            </b-row>
            <b-card no-body class="mb-1">
                <b-table
                    class="mb-0"
                    ref="tblOrderLines"
                    outlined
                    striped hover small
                    style="font-size:smaller;"
                    :items="ordLines.items"
                    :fields="ordLines.fields"
                    :current-page="ordLines.page"
                    :per-page="ordLines.limit"
                    show-empty
                    >
                    <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                    </template>
                    <template v-slot:cell(itemname)="data">
                        {{data.item.itemname}} 
                    </template>
                    <template v-slot:cell(qtyOrder)="data">
                        {{data.item.qtyOrder}} {{data.item.unitsize}}
                    </template>
                    <template v-slot:cell(priceOrder)="data">
                        {{data.item.priceOrder|numFormat}}
                    </template>
                    <template v-slot:cell(grossOrder)="data">
                        {{data.item.grossOrder|numFormat}}
                    </template>
                    <template v-slot:cell(discOrder)="data">
                        {{data.item.discOrder|numFormat}}
                    </template>
                    <template v-slot:cell(nettOrder)="data">
                        {{data.item.nettOrder|numFormat}}
                    </template>
                    <template v-slot:cell(action)="data">
                        <div class="text-center"> 
                        <a href="javascript:void(0)" @click="editOrderLines(data.item,data.toggleDetails)">
                            view
                        </a>
                        </div>
                    </template>
                    <template v-slot:row-details="row">
                        <b-card class="row-details-form">
                            <b-row  align-h="center">
                                <b-col lg="7" >
                                    <b-row no-gutters>
                                        <b-col md="8">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label>Sales Item</label></b-input-group-prepend>
                                                <b-form-input readonly v-model="ordLinesObj.itemname" disabled></b-form-input>
                                            </b-input-group>
                                        </b-col>
                                        <b-col md="4">                            
                                            <b-input-group>
                                                <b-input-group-prepend><span class="p-2">Quantity</span></b-input-group-prepend>
                                                <b-form-input v-model="ordLinesObj.qtyOrder" type="number" v-b-tooltip.hover :title="`Qty: ${ordLinesObj.qtyOrder}`" disabled></b-form-input>
                                                <b-form-input v-model="ordLinesObj.unitsize" class="ml-1" disabled></b-form-input>
                                            </b-input-group>
                                        </b-col>
                                    </b-row >
                                    <b-input-group>
                                        <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                                            <b-form-textarea :rows="2" :max-rows="3" v-model="ordLinesObj.description" disabled maxlength="250" placeholder="Jenis/Posisi/Halaman/Chanel"></b-form-textarea>
                                        <b-form-checkbox id="chkPrint" class="ml-1 mt-2" v-model="ordLinesObj.printhide" value="1" unchecked-value="0" disabled>No Print</b-form-checkbox>
                                    </b-input-group>
                                    <b-row no-gutters>
                                        <b-col md="6">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label >Price (Rate Card)</label></b-input-group-prepend>
                                                <b-input-group-prepend>
                                                    <span class="input-group-text" style="width:60px;">{{viewdata.matauang}}</span>
                                                </b-input-group-prepend>
                                                <my-number class="form-control text-right" v-model="ordLinesObj.priceOrder" :precision="2" disabled></my-number>
                                            </b-input-group>
                                        </b-col>
                                        <b-col md="6">                            
                                            <b-input-group>
                                                <b-input-group-prepend><span  class="p-2">Price Discount</span></b-input-group-prepend>
                                                <my-number v-model="ordLinesObj.priceDiscPc" :precision="2" v-b-tooltip.hover :title="ordLinesObj.priceDiscPc" disabled></my-number>
                                                <b-input-group-append><span class="ml-1 pt-2 mr-2"><i class="fa fa-percent"></i></span></b-input-group-append>
                                                <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{viewdata.matauang}}</span></b-input-group-prepend>
                                                <my-number class="form-control text-right" v-model="ordLinesObj.priceNett" :precision="2" style="width:40% !important;" disabled></my-number>
                                            </b-input-group>                                          
                                        </b-col>
                                    </b-row >   
                                    <b-row>
                                        <b-col md="6">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label >&nbsp;</label></b-input-group-prepend>
                                                <b-form-checkbox id="chkPPN" class="ml-1 mt-2" v-model="ordLinesObj.kenappn" value=1 unchecked-value=0 disabled >PPN (VAT Out)</b-form-checkbox>
                                                <b-input-group-prepend v-if="(ordLinesObj.kenappn == 1)"><span  class="p-2">tarif</span></b-input-group-prepend>
                                                <b-form-input v-if="(ordLinesObj.kenappn == 1)" v-model="ordLinesObj.ppn"  type="number" ></b-form-input>
                                                <b-input-group-append v-if="(ordLinesObj.kenappn == 1)"> <span class="input-group-text"><i class="fa fa-percent"></i></span></b-input-group-append>
                                            </b-input-group>
                                        </b-col>
                                        <b-col md="6">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label >Amount Due</label></b-input-group-prepend>
                                                <b-input-group-prepend>
                                                    <span class="input-group-text" style="width:60px;">{{viewdata.matauang}}</span>
                                                </b-input-group-prepend>
                                                <my-number class="form-control text-right" v-model="ordLinesObj.nilaidue" :precision="2" disabled></my-number>
                                            </b-input-group>
                                        </b-col>
                                    </b-row >   
                                        <div v-if="(ordLinesObj.required_jadwal==1)" style="float:right;">
                                            <b-input-group >
                                                <b-input-group-append>
                                                    <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </div>
                                </b-col>
                                <b-col lg="5">                                    
                                    <b-row v-if="(ordLinesObj.required_jadwal==1)" class="justify-content-center mb-0" >
                                      <div style="width:250 !important">
                                          <b-table 
                                          class="mb-0"
                                          ref="table"
                                          outlined hover small
                                          :items="ordJadwal.items"
                                          :fields="ordJadwal.fields" 
                                          :current-page="ordJadwal.page"
                                          :per-page="ordJadwal.limit"
                                          show-empty
                                        >
                                          <template v-slot:cell(index)="data">
                                            {{ (ordJadwal.page - 1) * ordJadwal.limit + (data.index + 1)}}
                                          </template>
                                          <template v-slot:cell(jadwalmuat)="data">
                                            <span v-if="(data.item.jadwalmuat)"> {{data.item.jadwalmuat | ambilNamaHari}}, {{data.item.jadwalmuat| moment('DD MMM YYYY')}} </span>
                                          </template>
                                          <template v-slot:cell(nilai)="data">
                                            {{data.item.nilai|numFormat('0,0.00')}}
                                          </template>
                                              <template v-slot:cell(empty)="scope">
                                                  <h4>{{ scope.emptyText }}</h4>
                                              </template>
                                              <template v-slot:cell(emptyfiltered)="scope">
                                                  <h4>{{ scope.emptyFilteredText }}</h4>
                                              </template>                        
                      
                                          </b-table>
                                          <b-row class="mb-0">
                                              <b-col cols="8" class="mb-0">
                                                  <b-row class="mb-0"> 
                                                  <div class="ml-2">
                                                      Total {{ordJadwal.total}} Jadwal, 
                                                      ditampilkan
                                                      <input type="number" style="width:50px;" v-model="ordJadwal.limit"/>

                                                      <strong v-if="(ordJadwal.total)">
                                                      {{(ordJadwal.page - 1) * ordJadwal.limit + 1}}
                                                      dari
                                                      {{ordJadwal.page * ordJadwal.limit}}
                                                      </strong>
                                                  </div>    
                                                  </b-row>
                                              </b-col>
                                              <b-col cols="4" class="mb-0">            
                                                <b-pagination
                                                    align="right"
                                                    :total-rows="ordJadwal.total"
                                                    :per-page="ordJadwal.limit"
                                                    v-model="ordJadwal.page"
                                                ></b-pagination>
                                              </b-col>
                                          </b-row>
                                      </div>
                                    </b-row>
                                    <!-- <v-dim v-else :model="ordLinesObj" :key="updateDimDtl" ></v-dim>                                     -->

                                    <b-row class="justify-content-center mt-1" v-if="(ordLinesObj.required_jadwal==0)">
                                        <div style="width:400px;">
                                            <b-input-group >
                                                <b-input-group-append>
                                                    <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </div>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </b-card>
                    </template>
                    <template v-slot:cell(empty)="scope">
                        <h4>{{ scope.emptyText }}</h4>
                    </template>
                    <template v-slot:cell(emptyfiltered)="scope">
                        <h4>{{ scope.emptyFilteredText }}</h4>
                    </template>                        
                </b-table>
                <b-row>
                    <b-col cols="5">
                        <b-row>
                        <div class="ml-3">
                            Showing
                            {{(ordLines.page - 1) * ordLines.limit + 1}}
                            to
                            {{ordLines.page * ordLines.limit}}
                            <strong>
                            of
                            {{ordLines.total}}
                            entries </strong>
                        </div>    
                        </b-row>                    
                    </b-col>
                    <b-col cols="3" >
                        <div class="pt-1">
                            Limit per page
                            <input type="number" style="width:80px;" v-model="ordLines.limit"/>
                        </div>
                    </b-col>        
                    <b-col cols="4">            
                    <b-pagination
                        align="right"
                        :total-rows="ordLines.total"
                        :per-page="ordLines.limit"
                        v-model="ordLines.page"
                    ></b-pagination>
                    </b-col>
                </b-row>
            </b-card>    
            <b-row align-h="between" class="mt-1">
                <b-col lg="8">
                    <b-row no-gutters>
                        <b-col lg="6">
                            <b-input-group >
                            <b-input-group-prepend><label>Bentuk Bayar</label></b-input-group-prepend>
                            <b-form-input v-model="viewdata.namajenisbayar" disabled  class="mr-5"></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><span class="input-group-text">Cara Bayar</span></b-input-group-prepend>
                                <b-form-radio-group inline class="p-1" v-model="viewdata.iscash" disabled >
                                    <b-form-radio value=0>Invoicing</b-form-radio>
                                    <b-form-radio value=1>Tunai (dimuka)</b-form-radio>
                                </b-form-radio-group>
                            </b-input-group>
                        </b-col>
                    </b-row>
                    <b-row no-gutters v-if="(viewdata.iscash!=1)">
                        <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label>Billing Invoice</label></b-input-group-prepend>
                                <b-form-input v-model="viewdata.billing" disabled  class="mr-5"></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col lg="6" >
                            <b-input-group v-if="(user.iklan==1)">
                                <b-input-group-prepend><span class="input-group-text">Tujuan Invoice</span></b-input-group-prepend>
                                <b-form-radio-group inline class="p-1" v-model="viewdata.billtoadv" disabled >
                                    <b-form-radio value=0>Agency</b-form-radio>
                                    <b-form-radio value=1>Advertiser</b-form-radio>
                                </b-form-radio-group>
                            </b-input-group>
                        </b-col>
                    </b-row>
                    <!-- <b-input-group v-if="(viewdata.billing=='PER TERMIN')">
                        <b-input-group-prepend><label>Termin Invoicing</label></b-input-group-prepend>
                        <b-form-input v-model="viewdata.keteranganbayar" disabled placeholder="Keterangan Termin Invoicing" class="mr-5"></b-form-input>
                    </b-input-group> -->
                    <div class="report-wraper" v-if="(viewdata.billing=='PER TERMIN')">
                      <table style="width: 99%;">
                          <thead>
                              <tr>
                                  <th width="80">Term</th>
                                  <th width="50">Tgl.Penagihan</th>
                                  <th style="text-align:right" width="140">Nilai</th>
                                  <th>Syarat & Kondisi</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr v-for="item in viewdata.terms" :key="item.namaterm">
                                  <td>{{item.namaterm}}</td>
                                  <td>
                                      {{item.tglterm | moment('DDMMMYYYY')}} 
                                  </td>
                                  <td style="padding:0 4px; text-align:right;">
                                      {{item.nilai  | numFormat}} 
                                  </td>
                                  <td style="padding:0 4px;">                           
                                      {{item.syarat}}
                                  </td>
                              </tr>
                          </tbody>
                      </table>
                    </div>

                  <!-- <div class="bordered"></div> -->
                  <!-- <transition name="slide-fade">
                    <div v-if="(viewdata.billtoadv==1)">
                      <b-input-group>
                        <b-input-group-prepend><label>Nama Advertiser</label></b-input-group-prepend>
                        <b-form-input v-model="viewdata.advnama" disabled placeholder="Nama Advertiser sesuai NPWP" style="width:40% !important;"></b-form-input>
                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">NPWP</span></b-input-group-prepend>
                        <b-form-input v-model="viewdata.advnpwp" disabled placeholder="NPWP"></b-form-input>
                      </b-input-group>
                      <b-input-group>
                        <b-input-group-prepend><label>Alamat Advertiser</label></b-input-group-prepend>
                        <b-form-input v-model="viewdata.advaddr1" disabled placeholder="Alamat 1"></b-form-input>
                      </b-input-group>
                      <b-input-group>
                        <b-input-group-prepend><label> </label></b-input-group-prepend>
                        <b-form-input v-model="viewdata.advaddr2" disabled placeholder="Alamat 2"></b-form-input>
                      </b-input-group>
                      <b-input-group>
                        <b-input-group-prepend><label>Telepon</label></b-input-group-prepend>
                        <b-form-input v-model="viewdata.advtelp" disabled placeholder="No Telepon"></b-form-input>
                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Fax</span></b-input-group-prepend>
                        <b-form-input v-model="viewdata.advcity" disabled placeholder="No. Fax"></b-form-input>
                      </b-input-group>
                    </div>
                  </transition> -->

                        <b-row v-if="(viewdata.matauang !== user.matauang)">
                            <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label >Exch. Rate <strong>{{viewdata.matauang}}</strong></label></b-input-group-prepend>
                                <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{user.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number  class="form-control text-right" separator="," v-model="viewdata.kursPPN" disabled></my-number>
                            </b-input-group>
                            </b-col>
                            <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label style="text-align: right !important;">Kurs Pajak <strong>{{viewdata.matauang}}</strong></label></b-input-group-prepend>
                                <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{user.matauang}}</span></b-input-group-prepend>
                                    <my-number class="form-control text-right" separator="," v-model="viewdata.kursPPN"  disabled></my-number>
                                </b-input-group>
                            </b-col>
                        </b-row>                      
                </b-col>
                <b-col lg="4">
                    <div class="text-right">
                        <b-input-group >
                            <b-input-group-prepend><label style="text-align: left; width:158px; padding-left:16px;">Gross</label></b-input-group-prepend>
                            <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{viewdata.matauang}}</span>
                            </b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="viewdata.ttlgross" :precision="2" disabled></my-number>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend><label style="text-align: left; width:158px; padding-left:16px;">Discount</label></b-input-group-prepend>
                            <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{viewdata.matauang}}</span>
                            </b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="viewdata.ttldiskon" :precision="2" disabled></my-number>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend><label style="text-align: left; width:158px; padding-left:16px;">Netto</label></b-input-group-prepend>
                            <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{viewdata.matauang}}</span>
                            </b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="viewdata.ttlnetto" :precision="2" disabled></my-number>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend><label style="text-align: left;width:158px; padding-left:16px;">PPN(VAT)</label></b-input-group-prepend>
                            <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{viewdata.matauang}}</span></b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="viewdata.ttlvat" :precision="2" disabled></my-number>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend><label style="text-align: left;width:158px; padding-left:16px;">Total Amount Due</label></b-input-group-prepend>
                            <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{viewdata.matauang}}</span>
                            </b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="viewdata.ttlamtdue" :precision="2" disabled></my-number>
                        </b-input-group>
                    </div>
                </b-col>
            </b-row>

            <b-row class="justify-content-center mb-2">
                    <button class="btn btn-danger mr-1" @click="showView=false" > <i class="fa fa-close"></i> Close</button>
            </b-row>

        </b-card>

    <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
      <p class="mb-1">1 record is about to be permanently deleted</p>
      <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
    </b-modal>

      <b-modal v-model="showApprovalConfirm" header-bg-variant="primary"  title="Approval Form" size="lg" :centered="true" hide-footer>
          <b-row>
              <b-col lg="6">
                  <b-input-group>
                      <b-input-group-prepend><label>Order Number</label></b-input-group-prepend>
                      <b-form-input v-model="model.nomor" readonly></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col lg="6">                            
                  <b-input-group>
                      <b-input-group-prepend><label>Order Date</label></b-input-group-prepend>
                      <b-form-input v-model="model.OrderDate" type="date"  disabled></b-form-input>                                        
                  </b-input-group>
              </b-col>
          </b-row >  
          <b-input-group >
              <b-input-group-prepend><label>Customer</label></b-input-group-prepend>
              <b-form-input v-model="model.custinfo"  readonly></b-form-input>
              <b-input-group-prepend><span class="input-group-text">Advertiser</span></b-input-group-prepend>
              <b-form-input v-model="model.Advertiser"  readonly></b-form-input>
          </b-input-group>
          <b-input-group >
              <b-input-group-prepend><label>Keterangan/Judul</label></b-input-group-prepend>
              <b-form-input v-model="model.uraian"  readonly></b-form-input>
          </b-input-group>
          <div v-if="(this.model.send2wf==1)">
            <label>Workflow process history</label>
            <div class="report-wraper">
                <table width="100%">
                <thead>
                <tr>
                <th width="120px">Assign Date</th>
                <th width="220px">Assign To</th>
                <th width="80px">Action Take</th>
                <th >Comment</th>
                <th width="120px">Complete Date</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="row in approvalHistory" :key="row.taskassignkey">
                  <td> {{row.assignstr | moment("dddd , DD-MMM-YYYY hh:mm:ss")}} </td>
                  <td>{{row.crewnik}} | {{row.crewname}}</td>
                  <td>{{row.actiontake}} 
                      <p v-if="(row.crewname !== row.actionBy)">{{row.actionBy}}</p></td>
                  <td>{{row.message}}</td>
                  <td><span v-if="(row.completeddate)">{{row.completeddate | moment("ddd DD-MMM-YYYY hh:mm:ss")}}</span></td>
                  </tr>
                  <tr> <td colspan="5" class="subtotal"></td></tr>
                  </tbody>
                  </table>
              </div>
              <b-row class="justify-content-center mt-1" > 
                  <b-button variant="primary" @click="printApproval"><i class="fa fa-print"></i> Print Approval</b-button>
                  <b-button variant="danger" class="ml-1" v-if="((model.iscomplete==0)  || (model.isreject==1) || (approvalHistory.length==0))" @click="showApprovalCancelConfirm=true" > <i class="fa fa-undo"></i> Cancel Approval</b-button>
                  <b-button variant="secondary" class="ml-1" @click="showApprovalConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
              </b-row>
          </div>
          <div no-body v-else>
            <label>Add Attachment</label>
              <b-form-file
              v-model="file"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              ></b-form-file>
              <div class="mt-3" >Selected file: <strong>{{ file ? file.name : '' }}</strong></div>   
              <b-row class="justify-content-center mt-1" v-if="(showConfirmNoFile)">
                  <label style="width:260px !important;">Send without attachment, are you sure?</label>
                    <b-form-radio-group  v-model="confirmNoFile"  class="ml-1" >
                        <b-form-radio :value="true">Yes</b-form-radio>
                        <b-form-radio :value="false">No</b-form-radio>
                    </b-form-radio-group>
              </b-row>
              <b-row class="justify-content-center mt-1" >
                  <b-button variant="primary" @click="approval"><i class="fa fa-paper-plane"></i> Send to Workflow</b-button>
                  <b-button variant="secondary" class="ml-1" @click="showApprovalConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
              </b-row>
          </div>
      </b-modal>
      <b-modal v-model="showApprovalCancelConfirm" title="Remove from workflow Approval Process?" :centered="true" @ok="approvalUndo">
        <p class="mb-1">The selected a row of data will be removed from Workflow?</p>
      </b-modal>

    <b-modal v-model="showInvoiceList" scrollable size="xl" title="Invoicing History" hide-footer>
      <b-form-row>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend><label>Sales Order Number</label></b-input-group-prepend>
            <b-form-input v-model="model.nomor" readonly></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend><label>Sales Order Date</label></b-input-group-prepend>
            <b-form-input :value="model.OrderDate | moment('DD MMM YYYY')" disabled></b-form-input>
          </b-input-group>
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend><label>Extr.PO Number</label></b-input-group-prepend>
            <b-form-input v-model="model.ExtrDocNo" readonly></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend><label>Customer</label></b-input-group-prepend>
            <b-form-input :value="`${model.CustCode} - ${model.CustName}`" readonly></b-form-input>
          </b-input-group>
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col cols="6">
          <b-input-group>
            <b-input-group-prepend><label>Sales Order Amount</label></b-input-group-prepend>
            <b-input-group-prepend
              ><span class="input-group-text" style="width: 60px">{{ model.matauang }}</span></b-input-group-prepend
            >
            <my-number class="form-control text-right" separator="," v-model="model.ttlamtdue" :precision="2" readonly></my-number>
          </b-input-group>
        </b-col>
      </b-form-row>
      <b-card no-body class="mb-1">
        <div class="report-wraper">
          <table style="width: 100%">
            <thead>
              <tr>
                <th width="80px">Invoice Date</th>
                <th width="110px">Invoice Number</th>
                <th>Description</th>
                <th width="90px">Input By</th>
                <th width="120px" style="text-align: right">Netto</th>
                <th width="120px" style="text-align: right">VAT</th>
                <th width="120px" style="text-align: right">DUE</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in invoice.items" :key="row.arinvkey">
                <td :class="row.kelas">{{ row.invdate | moment("DD MMM YYYY") }}</td>
                <td :class="row.kelas">{{ row.invoiceno }}</td>
                <td :class="row.kelas">{{ row.uraian1 }} {{ row.uraian2 }}</td>
                <td :class="row.kelas">{{ row.createby }}</td>
                <td :class="row.kelas" style="text-align: right">{{ row.ttlnetto | numFormat }}</td>
                <td :class="row.kelas" style="text-align: right">{{ row.ttlvat | numFormat }}</td>
                <td :class="row.kelas" style="text-align: right">{{ row.ttlamtdue | numFormat }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-card>
      <b-row class="mt-1">
        <b-col lg="6">
          <div class="text-right">
            <b-input-group>
              <b-input-group-prepend><label style="text-align: left; width: 158px; padding-left: 16px">Total Invoiced</label></b-input-group-prepend>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 60px">{{ invoice.matauang }}</span>
              </b-input-group-prepend>
              <my-number class="form-control text-right" v-model="invoice.invoiceTotal" :precision="2" disabled></my-number>
            </b-input-group>
          </div>
        </b-col>
        <b-col lg="6">
          <div class="text-right">
            <b-input-group>
              <b-input-group-prepend><label style="text-align: left; width: 158px; padding-left: 16px">Outstanding</label></b-input-group-prepend>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 60px">{{ invoice.matauang }}</span>
              </b-input-group-prepend>
              <my-number class="form-control text-right" v-model="invoice.outstand" :precision="2" disabled></my-number>
            </b-input-group>
          </div>
        </b-col>
      </b-row>
    </b-modal>



    <b-modal v-model="lkuKoranCustShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true">
      <lku-koran-cust @click="onSelectKoranCust"></lku-koran-cust>
    </b-modal>
    <b-modal v-model="lkuSalesShow" size="lg" :hide-footer="true" title="List of Sales Ex." :centered="true">
      <lku-salesae @click="onSelectsales"></lku-salesae>
    </b-modal>
    <b-modal v-model="lkuSalesCamapignShow" size="lg" :hide-footer="true" title="List of Campaign" :centered="true" >
      <lku-salescampaign @click="onSelectsalescamapign"></lku-salescampaign>
    </b-modal>

    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>

<style lang="scss">
  .list-of-so {
    table {
      td {
        .dropdown-item {
            padding: 0.1rem 1.5rem !important;
            font-size: smaller !important;
        }    
      }
    }
 }
</style>


<script>
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import moment from "moment";
toastr.init();

import myNumber from "../../components/my-number";
// LKU
import lkuSalescampaign from "../lookup/lkuSalesCampaign";
import lkuKoranCust from "../lookup/lkuCustomer";
import lkuSalesae from "../lookup/lkuSalesae";
// API
import task from "../../apis/task";
import salesorder from "../../apis/salesorder";

export default {
  components: { myNumber, lkuSalescampaign, lkuKoranCust, lkuSalesae },
  // mixins: [validationMixin],
  // validations: {
  // },
  data() {
    return {
      showDelConfirm: false,
      showApprovalConfirm: false,
      approvalHistory:[],
      file:null,
      confirmNoFile:false,
      showConfirmNoFile:'',
      showApprovalCancelConfirm: false,
      showInvoiceList: false,
      invoice: { items: [], invoiceTotal:0 },
      lkuSalesCamapignShow: false,
      lkuKoranCustShow: false,
      lkuSalesShow: false,
      byae: 0,
      SoMenu:'',
      showFilter: false,
      showReport: false,
      reportUrl: null,
      items:[],
      limit: 15,
      pagination:true,
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        tgl1: this.$store.state.user.tglaktif,
        tgl2: moment().format('YYYY-MM-DD'),
        sortBy: null,
        sortDesc: true,
        DimCol: "Dim1",
        outstand: "1"
      },
      user: this.$store.state.user,
      model:{},
      invoicingTerms:[
          {value:'DI AWAL', text: 'DI AWAL'},
          {value:'PER TERMIN', text: 'PER TERMIN'},
            {value:'PER TAYANG', text: 'PER TAYANG'},
            {value:'PER BULAN', text: 'PER BULAN'},
            {value:'DI AKHIR', text: 'DI AKHIR'},
            {value:'', text: '--semua--'}],
      YesNoAll:[
          {value:'1', text: 'YES'},
            {value:'0', text: 'NO'},
            {value:'', text: 'ALL'}],
      paymentForms:[{value:'STANDARD', text: 'Standard Cash/Bank'}],
      showView: false,
      viewdata: {
          OrderDate: '',
          customer_id: '',
          Advertiser: '',
          brand: '',
          kategori: '',
          matauang: this.$store.state.user.matauang, calcVAT:1, calcDisc:0, 
          nofaktur: '',
          tglfaktur: '',
          ttlamtdue: '', terms:[],
          kursPPN: 1,ttldiskon:0, iscash:0, billing:'DI AKHIR', billtoadv:0
      },
      ordLinesObj: {
          itemno:'', 
          iteminfo: '',itemname : '',
          description: '',
          qtyOrder: 0,
          nettOrder: 0,
          priceOrder:0,
          kenappn:1,printhide:0,
          priceDiscPc:0,priceDisc:0,priceNett:0
      },
      ordLines: {
          items: [],
          selected:{},
          fields: [
              {key: 'index', label: 'No.' ,thStyle: "width:40px"},                    
              {
                  key: "saleCrCode",
                  label: "Item Code",
              },
              {
                  key: "itemname",
                  label: "Item Name",
              },
              {
                  key: "description",
                  label: "Description",
              },
              {
                  key: "qtyOrder",
                  label: "Quantity",
                  thClass: "text-center",
                  tdClass: "text-center"
              },
              {
                  key: "priceOrder", 
                  label: "Price Order",
                  thStyle: "width:110px",
                  thClass: "text-right",
                  tdClass: "text-right"
              },
              {
                  key: "grossOrder", 
                  label: "Value Order",
                  thStyle: "width:110px",
                  thClass: "text-right",
                  tdClass: "text-right"
              },
              {
                  key: "discOrder", 
                  label: "Saving Value",
                  thStyle: "width:110px",
                  thClass: "text-right",
                  tdClass: "text-right"
              },
              {
                  key: "nettOrder", 
                  label: "Due/Nett",
                  thStyle: "width:110px",
                  thClass: "text-right",
                  tdClass: "text-right"
              },
              {
                  key: "action",
                  label: "Action",
                  thStyle: "width:40px",
                  thClass: "text-center",
              },
              {
                  key: "nettSales", 
                  label: "Acc. Booked Sales",
                  variant: "secondary",
                  thStyle: "width:110px",
                  thClass: "text-right",
                  tdClass: "text-right"
              },
          ],
          page: 1,
          limit: 5,
          total: 0,
      },
      ordJadwal: {
          items:[],
          fields:[
              {
                key: "index",
                label: "No",
                thStyle: "width:20px",
              },
              {
                key: "jadwalmuat",
                label: "Jadwal",
                thStyle: "width:200px",
                sortable: true
              },
            ],
          page: 1,
          limit: 10,
          total: 0,
      },

    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "action",
          label: "",
          thClass: "text-center",
        },
        {
          key: "OrderDate",
          label: "Order Date",
          tdClass: "text-center",
          thStyle: "width:90px",
          sortable: true
        },
        {
          key: "nomor",
          label: "Order Number",
          thStyle: "width:140px",
          sortable: true
        },
        {
          key: "custinfo",
          label: "Customer",
          sortable: true
        },
        {
          key: "Advertiser",
          label: "Advertiser",
        },
        {
          key: "kategori",
          label: "Category",
        },
        {
          key: "ExtrDocNo",
          label: "Cust. PO",
          thStyle: "width:150px",
        },
        {
          key: "uraian",
          label: "Note/Judul",
        },
        {
          key: "matauang",
          thStyle: "width:40px",
          label: "$,¥",
          sortable: true
        },
        {
          key: "ttlratecard",
          label: "Gross (Rate_Card)",
          thClass: "text-right",
          tdClass: "text-right",
          thStyle: "width:100px",
          sortable: true
        },
        {
          key: "savingvalue",
          label: "Saving Value",
          thClass: "text-right",
          tdClass: "text-right",
          thStyle: "width:100px",
          sortable: true
        },
        {
          key: "ttldiskon",
          label: "Disc.",
          thClass: "text-right",
          tdClass: "text-right",
          thStyle: "width:100px",
          sortable: true
        },
        {
          key: "ttlnetto",
          label: "Netto",
          thClass: "text-right",
          tdClass: "text-right",
          thStyle: "width:100px",
          sortable: true
        },
        {
          key: "invoiceno",
          label: "Invoice#",
          sortable: true
        },
        {
          key: "invoicetot",
          label: "Invoiced Amt.",
          thClass: "text-right",
          tdClass: "text-right",
          thStyle: "width:100px",
          sortable: true
        },
        {
          key: "salesae_name",
          label: "Sales/AE",
          thStyle: "width:90px",
          sortable: true
        },
        {
          key: "status",
          label: "Approval status",
          thStyle: "width:90px",
          sortable: true
        },
      ];

      // const dims = this.$store.state.dimension;
      // for (let i = 0; i < dims.length; i += 1) {
      //   fields.push({
      //     key: `${dims[i].value}Txt`,
      //     label: dims[i].text,
      //     sortable: true
      //   });
      // }
      return fields;
    },
   
    dimension() {
      return this.$store.state.dimension;
    }
  },
  watch: {
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    },    
    dimCol: function(newval) {
      this.tblData.DimVal = "";
      this.tblData.DimValInfo = "";
      this.tblData.DimColInfo = this.dimension.find(
        d => d.value === newval
      ).text;
    }
  },
  filters: {
    ambilNamaHari(tanggal) {
      const namesDay = [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jumat",
        "Sabtu"
      ];
      const day_ = namesDay[moment(tanggal).day()];
      return day_;
    }
  },  

  created: async function() {
    this.$store.commit("SoMenu", this.$route.name);
    this.SoMenu=this.$route.name;
    if (this.$route.params.byae==1)  {
      this.tblData.createby=this.$store.state.user.username;
      this.byae=1;
    }
    const f = await salesorder.paymentform() ;
      this.paymentForms = f.reduce((newArr,item) =>{
          newArr.push(item);
          return newArr;
      },[{ value: '', text: '--- ALL ---'}]);

  },
  methods: {
    onSelectsalescamapign(_selected) {
      this.tblData.campaign = `${_selected.uraian}`;
      // this.tblData.CampaignNo = _selected.campaignKey;
      this.tblData.CampaignKey = _selected.campaignKey;
      this.lkuSalesCamapignShow = false;
    },    
    onSelectKoranCust(_selected) {
      this.tblData.customer = _selected.CustCode;
      this.lkuKoranCustShow = false;
    },
    onSelectsales(_selected) {
      this.tblData.salesae_id = _selected.salesae_id;
      this.tblData.salesae_name = _selected.salesae_name;
      this.lkuSalesShow = false;
    },
    getInvoices: async function(record) {
        this.isLoading=true;
        let invoices;
        try {
          this.model=record;
          invoices = await salesorder.getInvoices(record);
          this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            console.log('error : ', error);
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }   
        } finally {
          this.invoice.items = invoices || [];
          let invoiceTotal = 0;
          this.invoice.items.forEach(function (trx) {
            invoiceTotal += trx.ttlamtdue || 0;
          });
          this.invoice.invoiceTotal = invoiceTotal;
          this.invoice.outstand = parseFloat(this.model.ttlamtdue) - invoiceTotal;
          this.$forceUpdate();
          this.showInvoiceList = true;
          
        }    
    },
    attachmentDownload : async function(fl) {
        this.isLoading=true;
        try {
            await salesorder.attachmentDownload(fl);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            console.log('error : ', error);
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }   
        }
    },       
    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.SalesorderList) {
            this.tblData[key] = filter.SalesorderList[key];
            filtered=true;
        }
        if (filtered === true) {
          this.tblData.tgl1=filter.SalesorderList.tgl1 || '';
          this.tblData.tgl2=filter.SalesorderList.tgl2 || '';
          this.showFilter=filtered;
          delete filter.SalesorderList;
          this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=true; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await salesorder.list(this.tblData);
                  this.pagination=true;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
                }
            }

        } else {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await salesorder.list(this.tblData);
                  this.pagination=true;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
                }
        }
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    togleFilter() {
      this.showFilter = !this.showFilter;
    },
    clearFilter(ctx) {
      this.tblData.customer = "";
      this.tblData.customer_id = "";
      this.tblData.Advertiser = "";
      this.tblData.campaign = "";
      this.tblData.campaignKey = "";
      this.tblData.tgl1 = "";
      this.tblData.tgl2 = "";
      this.tblData.uraian = "";
      this.tblData.nomor = "";
      this.tblData.ExtrDocNo = "";
      this.tblData.salesae_id = "";
      this.tblData.salesae_name = "";
    },
    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    saveFilter() {
      const keys = ['Advertiser', 'brand', 'campaign', 'campaignKey', 'customer', 'customer_id', 'DimCol', 'DimColInfo', 'DimVal', 'ExtrDocNo', 'iscompliment', 'isdiscount', 'issavingrate', 'nomor', 'salesae_id', "salesae_name", 'tahun', 'tgl1', 'tgl2', 'status', 'uraian', 'createby','billing', 'isinvoiced', 'completed', 'jenisbayar'];
      let filtered = false;
      const SalesorderList={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              SalesorderList[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          SalesorderList.page=this.tblData.page;
          SalesorderList.limit=this.tblData.limit;
          SalesorderList.sortBy=this.tblData.sortBy;
          SalesorderList.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.SalesorderList=SalesorderList;
          this.$store.commit("filter", filter);
      }
    },   
    rowApproval(record) {
      this.rowClicked(record);
        this.approvalConfirm();        
    },
    rowView(record) {
      this.model = record;
      this.view();
    },
    rowEdit(record) {
      this.model = record;
      this.edit();
    },
    rowPrint(record) {
      this.rowClicked(record);
        this.print();        
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();

    },
    add: function() {
      this.saveFilter();
      router.push({ name: "sales.customerorderfrm", params:{byae: this.byae} });
    },
    edit: function() {
      if (!this.model.salesHdrKey) {
            toastr.warn('Please select a row that want to be Edit!');
      } else {
        if (this.model.invoiced==1) {
            toastr.warn('Sales Order tidak bisa di-edit dari menu ini, karena sudah di-invoice-kan!');
        } else if ((this.model.status=='100') || (this.model.status=='110')) {
            toastr.warn('Lakukan CANCEL APPROVAL sebelum mneg-edit Sales Order ini, karena sudah masuk proses Approval!');
        } else if (this.model.status=='111') {
            toastr.warn('Sales Order tidak bisa di-edit dari menu ini, karena sudah di-Approval!');
        } else {
          this.saveFilter();
          router.push({
            name: "sales.customerorderfrm",
            params: { salesHdrKey: this.model.salesHdrKey, byae: this.byae }
          });
        }
      }
    },
    view: async function() {
            this.showView=true;
            const data = await salesorder.detail({salesHdrKey: this.model.salesHdrKey});
            const row = data[0];
            row.OrderDate = row.OrderDate ? moment(row.OrderDate).format('YYYY-MM-DD') : '';
            for (var key in row) {
                this.viewdata[key] = row[key];
            }
            this.viewdata.namajenisbayar = this.viewdata.namajenisbayar || this.viewdata.jenisbayar;
            this.ordLines.items = data[1]
            this.viewdata.terms= data[2];
            this.ordLines.total=this.ordLines.items.length;
            this.viewdata.calcVAT = this.viewdata.calcVAT || 1;
            this.viewdata.calcDisc = this.viewdata.calcDisc || 0;
            let nilaidpp = 0;
            let ttlvat = 0;
            let ttlgross = 0;
            // let ttldiskon = 0;
            let totaldpp = 0;
            this.ordLines.items.forEach( function (trx) {
                if (trx.itemno) {
                    nilaidpp += (trx.dpp || 0);
                    ttlgross += (trx.nettOrder || 0);
                    // ttldiskon += (trx.discOrder  || 0);
                    ttlvat += (trx.nilaippn || 0);
                }
            });
            this.viewdata.nilaidpp = nilaidpp;
            this.viewdata.ttlgross = ttlgross;
            if (this.viewdata.calcVAT == 1){
                this.viewdata.ttlvat = ttlvat;
            }
            this.viewdata.ttlnetto =this.viewdata.ttlgross-this.viewdata.ttldiskon;
            this.viewdata.ttlamtdue = this.viewdata.ttlnetto+this.viewdata.ttlvat;

      
    },
    closeOrderLines: function(){
        const opened= this.ordLines.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    editOrderLines : function (obj,callback) {
        this.closeOrderLines();
        this.ordLines.selected = obj;
        // for (var key in this.ordLinesObj) {
        //     this.ordLinesObj[key] = '';
        // }
        // this.dimension.forEach(dim => {
        //     if (obj[`${dim.value}Txt`]) {
        //     obj[`${dim.value}Info`] = obj[`${dim.value}Txt`];
        //     }
        // });
        for (var key in obj) {
            this.ordLinesObj[key] = obj[key];
        }
        this.ordJadwal.items=[];
        const arrJadwal=JSON.parse(obj.jadwal); 
        arrJadwal.forEach((jd,idx)=>{
        this.ordJadwal.items.push({jadwalmuat: new Date(jd)});
        });            
        this.ordJadwal.total=this.ordJadwal.items.length;
        this.ordLinesObj.typeseries = `${obj.itemcategory}`;
        // this.dimension.forEach((dim) => {
        //     if (obj[dim.value]) {
        //         this.ordLinesObj[dim.value] = obj[dim.value];
        //         this.ordLinesObj[`${dim.value}Txt`] = obj[`${dim.value}Txt`];
        //         this.ordLinesObj[`${dim.value}Info`] = obj[dim.value] + ' | '+ obj[`${dim.value}Txt`];
        //     }
        // });
        callback();
    },

    deleteConfirm(item) {
      if (!this.model.salesHdrKey) {
            toastr.warn('Please select a row that want to be Edit!');
      } else {
        this.showDelConfirm = true;
      }
    },
    deleteData: async function() {
      try {
        this.isLoading=true;
        await salesorder.remove(this.model);
      this.refresh();
        // const index= this.items.findIndex(r => (r.salesHdrKey==this.model.salesHdrKey));
        // this.items.splice(index, 1);
        this.isLoading=false;
      } catch (error) {
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },
    async print() {
      if (!this.model.salesHdrKey) {
        toastr.info("Select 1 row detail first.");
      } else {
      this.reportUrl=null; this.showReport = true;

        this.reportUrl = await salesorder.print(this.model);

        // this.reportUrl = await salesorder.print(this.model);
//         if (this.$isMobile()){
//             window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
//         } else {
//           this.showReport=true;
//         }
      }
    },
    exportxls: async function() {
      this.isLoading = true;
      try {
        await salesorder.exportxls(this.tblData);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    approvalConfirm: async function () {
        if (this.model.salesHdrKey) {
            if (this.model.send2wf==1) {
              try {
                const data = await task.approvalhistory({key: this.model.salesHdrKey});
                this.approvalHistory=data;                
              } catch (error) {
                if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }                
              }
            }
            this.model.OrderDate = this.model.OrderDate ? moment(this.model.OrderDate).format('YYYY-MM-DD') : '';
                this.showApprovalConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be sent to workflow Approval!');
        }
    }, 
    approval: async function(evt){
        evt.preventDefault()
        try {
            const formData = new FormData();
            if (!(this.file)) {
              if (this.confirmNoFile==false){
                toastr.info('Send without attachment, are you sure?');
                this.showConfirmNoFile=true;
                return;
              }
            } else {
              formData.append('file', this.file);
              formData.append('filename', this.file.name);
            }
            formData.append('tablekey', this.model.salesHdrKey);
            this.showApprovalConfirm = false;
            this.isLoading=true;
            const resp = await salesorder.approval(formData);
            this.model.send2wf=1;
            this.refresh();
            this.isLoading=false;
            if (resp.message) {
                toastr.warn(resp.message,'warning',10000);
            }
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    approvalUndo: async function(){
        this.isLoading=true;
        try {
            await salesorder.approvalUndo(this.model);
            this.model.send2wf=0;
            this.showApprovalConfirm = false;
            this.refresh();
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    printApproval: async function()
    {
      if (this.model.salesHdrKey) {
          this.isLoading=true;
          try {
                this.showReport=true;
              this.reportUrl= await task.approvalprint({key: this.model.salesHdrKey});
              this.isLoading=false;
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },      
    
    close() {
      router.push({name: "sales.home"});
    }
  }
};
</script>
